import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
import globals from '@/plugins/globals.js'

// const authUrl = window.config ? window.config.authUrl : ''
const unknownError = 999

// a helper method to collect vee validation child components
function collectChildValidation($this, validations) {
  $this.$children.forEach(vm => {
    validations.push(vm.$validator.validateAll())
    if (vm.$children.length) {
      collectChildValidation(vm, validations)
    }
  })
}

function getMahleApiErrorMsg(errorNo, msg) {
  var outputErr = ''
  const genericMsg = 'Check the status of the Wifi connection, try again and if the problem persists, please contact technical assistance.'
  switch (errorNo) {
    case 100: // Generic Unmanaged Error
      outputErr = `Generic unmanaged error.`
      break
    case 200: // Missing registration Data
      outputErr = `Mandatory data missing: (${msg}).`
      break
    case 204: // No Content
      outputErr = `No coin data available.`
      break
    case 300: // Login Error
      outputErr = `Wrong username.`
      break
    case 400: // Missing Astech_sn
      outputErr = `SN is not associated with any of our devices.`
      break
    case 500: // Missing registration data
      outputErr = `Missing registration data.`
      break
    case 600: // Missing Or Expired License
      outputErr = `Diagnostic Licence Expired.`
      break
    case 700: // List of missing mandatory fields
      outputErr = 'Some mandatory fields are missing in the submitted json report.'
      break
    case 800: // JSON not valid
      outputErr = 'The supplied json report is not valid json format.'
      break
    case 900: // Missing Work Order number
      outputErr = 'The work order number is required but hasn\'t been supplied.'
      break
    default: // Anything else
      outputErr = `Unknown error.`
      break
  }
  return `${outputErr} \r\n ${genericMsg}`
}
export default {
  clearToken({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setPassthrough({ commit }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  setSolution({ commit }, solution) {
    commit(types.SET_SOLUTION, solution)
  },
  async getToken({ commit, getters, dispatch }, [user, pwd, demoMode, solution]) {
    commit(types.RESET_LOGIN)
    commit(types.SET_SOLUTION, solution)
    const t = await startLoading(dispatch, 'getToken', () =>
      http.post('getToken', { user, pwd }, {}, globals.authUrl())
    )
    commit(types.SET_TOKEN, t.data)
    commit(types.SET_DEMO_MODE, demoMode)
    if (getters.user && getters.user.prn) {
      const r = await startLoading(dispatch, 'getUserByName', () =>
        http.get('user/getUserByName', { params: { username: user } })
      )

      commit(types.SET_USER_ISMAHLE, r.data[0].IsMahle)
      commit(types.SET_ROLES, r.data[0])
      commit(types.SET_FULL_USER_DATA, r.data[0])

      // Check if user has RAG Only role and set flag
      const hasRagOnlyRole = r.data[0].Roles &&
      r.data[0].Roles.some(role => {
        const isRagRole = role.Id === 14
        return isRagRole
      })

      // Check if user has ShowRAG permission
      const hasShowRagPermission = r.data[0].ShowRAG === true || r.data[0].ShowRAG === 1

      // Store the RAG Only status for router guard to use
      commit('SET_USER_RAG_ONLY', hasRagOnlyRole)
      // Store the ShowRAG permission
      commit('SET_USER_SHOW_RAG', hasShowRagPermission)

      const u = await startLoading(dispatch, 'getContactIdByUserId', () =>
        http.get(`user/getContactIdByUserId?userId=${r.data[0].UserId}`)
      )
      commit(types.SET_CONTACT_ID, u.data)
      const s = await startLoading(dispatch, 'getLocationKey', () =>
        http.get(`BusinessQuery/LocationById?id=${r.data[0].Location.Id}`)
      )
      commit(types.SET_LOCATION_KEY, s.data)

      // Make call to Mahle Api and get coin count and license status
      commit(types.SET_MAHLE_COIN_COUNT, 200)
      commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, 'Active')

      // Return user data so login component can handle routing
      return { userData: r.data[0], hasRagOnlyRole }
    }
    return { userData: null, hasRagOnlyRole: false }
  },
  veeValidateAll({ commit }, $this) {
    return new Promise((resolve, reject) => {
      let validations = [$this.$validator.validateAll()]
      collectChildValidation($this, validations)
      Promise.all(validations)
        .then(r => resolve(r.every(i => i === true)))
        .catch(reject)
    })
  },
  logout({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setContact({ commit }, id) {
    commit(types.SET_CONTACT, id)
  },
  setUserInfo({ commit }, userInfo) {
    commit(types.SET_USERINFO, userInfo)
  },
  setPhone({ commit }, phone) {
    commit(types.SET_PHONE, phone)
  },
  updateContact({ commit }, data) {
    commit(types.UPDATE_CONTACT, data)
  },
  async setLanguage({ commit, dispatch }, contact) {
    commit(types.SET_LANGUAGE, contact.language)
    let appId = globals.appId()
    // If app solution not Glass, proceed...
    if (appId !== 2) {
      await startLoading(dispatch, 'setLanguage', () =>
        http.post('User/UpdateContact', contact)
      )
    }
  },
  showLogging({ commit }, isShow) {
    commit(types.SHOW_LOGGING, isShow)
  },
  setLogging({ commit }, data) {
    commit(types.SET_LOGGING, data)
  },
  setLogEntry({ commit }, data) {
    commit(types.SET_LOG_ENTRY, data)
  },
  clearLog({ commit }) {
    commit(types.CLEAR_LOG)
  },
  async setNotificationToken({ commit, dispatch }, token) {
    commit(types.SET_NOTIFICATION_TOKEN, token.token)
    await startLoading(dispatch, 'setNotificationToken', () =>
      http.post('User/SetFirebaseToken', token)
    )
  },
  async getLocationKey({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getLocationKey', () =>
      http.get(`BusinessQuery/LocationById?id=${id}`)
    )
    commit(types.SET_LOCATION_KEY, r.data)
  },
  async getBusinessUsers({ commit, dispatch, state }) {
    const r = await startLoading(dispatch, 'getBusinessUsers', () =>
      http.get(`BusinessQuery/Users?key=${state.userProfile.location.key}`)
    )
    commit(types.SET_BUSINESS_USERS, r.data)
  },
  async upsertBusinessContact({ commit, dispatch }, contact) {
    const t = await startLoading(dispatch, 'upsertBusinessContact', () =>
      http.post('Business/ModifyUsers', contact)
    )
    return t.data
  },
  async getBusinessContact({ dispatch }, contact) {
    const t = await startLoading(dispatch, 'getBusinessContact', () =>
      http.get(`BusinessQuery/BusinessContactGet?id=${contact}`)
    )
    return t.data
  },
  async checkIfBanned({ commit, dispatch, state }, solution) {
    let url = globals.lookupUrl(solution)
    if (state.userToken !== null) {
      const r = await startLoading(dispatch, 'checkIfBanned', () =>
        http.get(`User/CheckIfBanned?id=${state.userToken.id}&token=${state.userToken.token}`, {}, {}, url)
      )
      commit(types.SET_USER_INFO, r.data)
      return r.data
    }
    return null
  },
  async setMahleDisplayValues({ commit, getters, dispatch }, [asTechSn]) {
    commit(types.RESET_MAHLE_COIN_BALANCE)
    commit(types.RESET_MAHLE_DIAGNOSTIC_LICENSE_STATUS)
    commit(types.RESET_MAHLE_API_ERROR_MSG)
    console.log(`ACTION setMahleDisplayValues: ${asTechSn}`)
    // Call Mahle Api Endpoint
    var result = null
    try {
      result = await startLoading(dispatch, 'getMahleCoinBalance', () =>
        http.get(`Mahle/CurrentCoinBalance?asTechSn=${asTechSn}`)
      )
      if (result) {
        if (result.data.status !== null && result.data.status !== undefined) {
          if (result.data.status === false) {
            commit(types.SET_MAHLE_COIN_COUNT, '?')
            commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, (result.data.error === 600 ? 'Expired' : 'Active'))
            commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error || unknownError, result.data.errorText || ''))
          } else {
            // Api call was successful and hopefully contains the Mahle coin balance.
            commit(types.SET_MAHLE_COIN_COUNT, (result.data.error === 0 ? result.data.balance : '?'))
            commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, (result.data.error === 600 ? 'Expired' : 'Active'))
          }
        } else {
          // Api call was unsuccessful so use '?' to Indicate that there was some issue but don't stop processing.
          commit(types.SET_MAHLE_COIN_COUNT, '?')
          commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, '?')
          commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error || unknownError, result.data.errorText || ''))
        }
      } else {
        // Api call was unsuccessful so use '?' to Indicate that there was an unknown error.
        commit(types.SET_MAHLE_COIN_COUNT, '?')
        commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, '?')
        commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error || unknownError, result.data.errorText || ''))
      }
    } catch (e) {
      // There was some issue but don't stop processing.
      console.log(`Api call returned Error: ${e}`)
      commit(types.SET_MAHLE_COIN_COUNT, '?')
      commit(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, '?')
      commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error || unknownError, result.data.errorText || ''))
    }
  },
  async insertAuditInfo({ dispatch }, auditInfo) {
    const t = await startLoading(dispatch, 'insertAuditInfo', () =>
      http.post('TC/AddAuditInfo', auditInfo)
    )
    return t.data
  },
  async getTermAndConditionsUIMessage({ commit, dispatch }) {
    const t = await startLoading(dispatch, 'getTermAndConditionsUIMessage', () =>
      http.get('TC/GetUIMessage')
    )
    commit(types.SET_TERMANDCONDITIONS_UI_MESSAGE, t.data)
  },
  async downloadCurrentTermsAndConditionDocument({ commit }) {
    let url = globals.apiUrl() + '/TC/TermsAndConditions'
    window.open(`${url}`, '_blank')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js